import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import {
  MARKETING_PARTNER_LISTING_STATUS_LANDLORD_INVITED,
} from 'common/marketingPartnerListingConstants';

import {
  DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
} from 'common/dataTableConstants';

import {
  dataTable,
} from 'client/helpers/dataTables';

import {
  hasRoleLandlord,
} from 'common/userRoles';

import {
  getUserLandingPage,
} from 'client/helpers/allowedRoles';

import withTransitionHook from 'client/helpers/withTransitionHook';

import branch from 'client/core/branch';
import LandlordActions from 'client/actions/Landlord';

@branch({
  currentUser: ['currentUser'],
})
@dataTable((props) => ({
  itemsPropName: 'marketingPartnerListings',
  dataSource: DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
  viewId: `landlord-${props.currentUser.landlordId}`,
  count: 100,
  filter: {
    'listings.landlordId': props.currentUser.landlordId,
  },
  sort: {
    'marketingPartnerListings.createdDate': 'desc',
  },
}))
@withTransitionHook
class LandlordOverviewRedirectPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Owner Overview | Sunroom Rentals',
  })

  static fetchData(match, inject) {
    const currentUser = inject.state.get(['currentUser']);
    if (hasRoleLandlord(currentUser.roles)) {
      return LandlordActions.getMarketingPartnerListings(inject, {
        landlordId: currentUser.landlordId,
      });
    }
  }

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
  }

  render() {
    const {
      currentUser,
      marketingPartnerListings,
      isTransitioning,
    } = this.props;

    if (isTransitioning) {
      return null;
    }

    const marketingPartnerListing = marketingPartnerListings[0];

    if (!hasRoleLandlord(currentUser.roles)) {
      const userLandingPage = getUserLandingPage({
        userRoles: currentUser.roles,
      });

      return (
        <Redirect to={userLandingPage} />
      );
    }

    let redirectTo = '/feed';

    if (marketingPartnerListing) {
      redirectTo = marketingPartnerListing.status === MARKETING_PARTNER_LISTING_STATUS_LANDLORD_INVITED
        ? `/partner/${marketingPartnerListing.partner.slug}/market-property/${marketingPartnerListing.id}`
        : `/partner/${marketingPartnerListing.partner.slug}/listing/${marketingPartnerListing.listingId}`;
    }

    return (
      <Redirect to={redirectTo} />
    );
  }
}

LandlordOverviewRedirectPage.displayName = 'LandlordOverviewRedirectPage';

export default LandlordOverviewRedirectPage;
